/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { makeAPI } from "@/frameworks/core/API";
import GroupService from "./api";

export default function withGroupInvite(events: API.Events) {
	return {
		invite: {
			cancel: makeAPI<WebServices.GroupInvite.Cancel.Response>(
				GroupService.groupInvite.cancel("invite:cancel", events)
			),
			list: makeAPI<WebServices.GroupInvite.List.Response>(GroupService.groupInvite.list("invite:list", events)),
			inquiry: makeAPI<WebServices.GroupInvite.Inquiry.Response>(
				GroupService.groupInvite.inquiry("invite:inquiry", events)
			),
			invite: makeAPI<WebServices.GroupInvite.Invite.Response>(
				GroupService.groupInvite.invite("invite:invite", events)
			),
			process: makeAPI<WebServices.GroupInvite.Process.Response>(
				GroupService.groupInvite.process("invite:process", events)
			)
		}
	};
}
